export function onOpenSpeakerMenu(event, speakerId, indexLine) {
  if (this.props.readOnly) {
    return;
  }

  this.setState({
    speakerMenu: {
      display: true,
      x: event.clientX,
      y: event.nativeEvent.offsetY,
      speakerId,
      indexLine
    }
  });
}

export function onCloseSpeakerMenu() {
  this.setState({
    speakerMenu: {
      display: false,
      x: null,
      y: null,
      speakerId: null,
      indexLine: null
    },
  });
}

// ***************************************************************************************
// onSelectSpeaker()
// Appelée quand l'utilisateur sélectionne un speaker du menu
// ***************************************************************************************
export function onSelectSpeaker(speakerId) {
  this.subtitle.lines[this.state.speakerMenu.indexLine].speakerId = speakerId;

  this.subtitle.lines
    .filter(x => x.speakerId === undefined)
    .forEach(line => {
    line.speakerId = speakerId
  });


  this.onCloseSpeakerMenu();
  this.onChange();

  setTimeout(() => {
    this.props.onUpdateAppearenceSpeakers();
  }, 100);
}
